const COLORS = ["#E02189", "#AD1C5D", "#67DAD7", "#F8D4DE", "#400057", "#9D84AF", "#FFD166", "#FFFFFF"];

function root() {
  const r = document.createElement("div");
  r.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:9999;overflow:hidden";
  document.body.appendChild(r);
  return r;
}

function piece(r, x, y, kind) {
  const p = document.createElement("div");
  const size = 7 + Math.random() * 11;
  const c = COLORS[Math.floor(Math.random() * COLORS.length)];
  let shape = `width:${size}px;height:${size * 0.45}px;border-radius:2px;background:${c}`;
  if (kind === 1) shape = `width:${size}px;height:${size}px;border-radius:50%;background:${c}`;
  if (kind === 2) shape = `width:0;height:0;border-left:${size / 2}px solid transparent;border-right:${size / 2}px solid transparent;border-bottom:${size}px solid ${c}`;
  if (kind === 3) shape = `width:${size * 0.5}px;height:${size * 1.8}px;border-radius:${size}px;background:${c}`;
  p.style.cssText = `position:absolute;left:${x}px;top:${y}px;opacity:0.98;${shape};will-change:transform,opacity`;
  r.appendChild(p);
  return p;
}

function burst(r, x, y, count, spread, power) {
  for (let i = 0; i < count; i++) {
    const p = piece(r, x, y, i % 4);
    const angle = (-90 + (Math.random() - 0.5) * spread) * (Math.PI / 180);
    const v = power * (0.55 + Math.random() * 0.75);
    const vx = Math.cos(angle) * v;
    const vy = Math.sin(angle) * v;
    const dur = 2600 + Math.random() * 1800;
    const g = 1100 + Math.random() * 500;
    const t = dur / 1000;
    const endX = vx * t;
    const endY = vy * t + 0.5 * g * t * t;
    const rot = Math.random() * 1080 - 540;
    p.animate(
      [
        { transform: "translate(0,0) rotate(0deg) scale(1)", opacity: 1, offset: 0 },
        { transform: `translate(${endX * 0.35}px, ${vy * t * 0.4}px) rotate(${rot * 0.3}deg) scale(1.1)`, opacity: 1, offset: 0.3 },
        { transform: `translate(${endX}px, ${endY}px) rotate(${rot}deg) scale(0.8)`, opacity: 0, offset: 1 },
      ],
      { duration: dur, easing: "cubic-bezier(0.15,0.55,0.35,1)", fill: "forwards" }
    );
    setTimeout(() => p.remove(), dur + 50);
  }
}

function rain(r, count) {
  const w = window.innerWidth;
  for (let i = 0; i < count; i++) {
    const p = piece(r, Math.random() * w, -30, i % 4);
    const dx = (Math.random() - 0.5) * 360;
    const dur = 3200 + Math.random() * 2600;
    const delay = Math.random() * 1800;
    p.animate(
      [
        { transform: "translate(0,0) rotate(0deg)", opacity: 1 },
        { transform: `translate(${dx * 0.5}px, ${window.innerHeight * 0.5}px) rotate(${Math.random() * 540}deg)`, opacity: 1, offset: 0.5 },
        { transform: `translate(${dx}px, ${window.innerHeight + 60}px) rotate(${Math.random() * 1080}deg)`, opacity: 0.9 },
      ],
      { duration: dur, delay, easing: "cubic-bezier(0.2,0.6,0.4,1)", fill: "forwards" }
    );
    setTimeout(() => p.remove(), dur + delay + 50);
  }
}

export function fireConfetti() {
  const r = root();
  rain(r, 160);
  setTimeout(() => r.remove(), 7000);
}

export function fireCelebration() {
  const r = root();
  const w = window.innerWidth;
  const h = window.innerHeight;
  // cannons from both bottom corners, then a center burst, then rain
  burst(r, w * 0.05, h * 0.95, 110, 70, 1250);
  burst(r, w * 0.95, h * 0.95, 110, 70, 1250);
  setTimeout(() => burst(r, w * 0.5, h * 0.6, 160, 180, 1050), 350);
  setTimeout(() => rain(r, 220), 500);
  setTimeout(() => { burst(r, w * 0.25, h * 0.9, 80, 90, 1100); burst(r, w * 0.75, h * 0.9, 80, 90, 1100); }, 1500);
  setTimeout(() => r.remove(), 9000);
}
